// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* FilterMenu.module.css */

/* невидимый фон за фильтром */
.FilterMenu_backdrop__L48iT {
  position: fixed;
  inset: 0;
  background: transparent;
  z-index: 5004;
}

/* само окно фильтра */
.FilterMenu_overlay__B0x6U {
  position: fixed;
  bottom: 65px;
  left: 50%;
  transform: translateX(-50%);
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0 3px 10px rgba(0,0,0,0.2);
  display: flex;
  flex-direction: column;
  padding: 10px;
  gap: 8px;
  width: 250px;
  z-index: 5005;
}

/* элементы внутри */
.FilterMenu_item__j-rEQ {
  background: none;
  border: none;
  padding: 10px;
  font-size: 16px;
  text-align: left;
  cursor: pointer;
  transition: background 0.2s;
  color: #333;
}

.FilterMenu_item__j-rEQ:hover {
  background-color: #f0f0f0;
}

.FilterMenu_active__Kz9J7 {
  background-color: #007bff;
  color: #ffffff;
}

.FilterMenu_active__Kz9J7:hover {
  background-color: #007bff;
}
`, "",{"version":3,"sources":["webpack://./src/modules/Courier/Route/FilterMenu.module.css"],"names":[],"mappings":"AAAA,0BAA0B;;AAE1B,8BAA8B;AAC9B;EACE,eAAe;EACf,QAAQ;EACR,uBAAuB;EACvB,aAAa;AACf;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,mBAAmB;EACnB,sCAAsC;EACtC,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,aAAa;AACf;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/* FilterMenu.module.css */\r\n\r\n/* невидимый фон за фильтром */\r\n.backdrop {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: transparent;\r\n  z-index: 5004;\r\n}\r\n\r\n/* само окно фильтра */\r\n.overlay {\r\n  position: fixed;\r\n  bottom: 65px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  background: #ffffff;\r\n  border-radius: 10px;\r\n  box-shadow: 0 3px 10px rgba(0,0,0,0.2);\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 10px;\r\n  gap: 8px;\r\n  width: 250px;\r\n  z-index: 5005;\r\n}\r\n\r\n/* элементы внутри */\r\n.item {\r\n  background: none;\r\n  border: none;\r\n  padding: 10px;\r\n  font-size: 16px;\r\n  text-align: left;\r\n  cursor: pointer;\r\n  transition: background 0.2s;\r\n  color: #333;\r\n}\r\n\r\n.item:hover {\r\n  background-color: #f0f0f0;\r\n}\r\n\r\n.active {\r\n  background-color: #007bff;\r\n  color: #ffffff;\r\n}\r\n\r\n.active:hover {\r\n  background-color: #007bff;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"backdrop": `FilterMenu_backdrop__L48iT`,
	"overlay": `FilterMenu_overlay__B0x6U`,
	"item": `FilterMenu_item__j-rEQ`,
	"active": `FilterMenu_active__Kz9J7`
};
export default ___CSS_LOADER_EXPORT___;
